import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-takt',
  templateUrl: './takt.component.html',
  styleUrls: ['./takt.component.css']
})
export class TaktComponent {

  @Input() takt: string = '--:--:--'
  @Input() bgColor: string = 'white'

}